import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  useColorModeValue,
  Center,
} from "@chakra-ui/react";
import ContactUsBox from "../ContactUs";

function BlindfoldInfo() {
  return (
    <Container
      maxW="container.md"
      px={{ base: 4, md: 6 }} // Responsive padding
      py={{ base: 2, md: 4 }}
      bg={useColorModeValue("white", "gray.700")} // Light & Dark mode support
      borderRadius="lg"
      boxShadow="lg"
    >
      {/* Main Heading */}
      <Heading size="lg" textAlign="center" mb={4}>
        Blindfold Capital
      </Heading>

      {/* Description */}
      <VStack spacing={3} align="stretch">
        <Text
          fontSize={{ base: "sm", md: "md" }}
          textAlign={{ base: "left", md: "justify" }}
        >
          Blindfold Capital is a decentralized finance (DeFi) application
          designed to automate the management of cryptocurrency positions on
          perpetual options exchanges. Built on the Arbitrum blockchain,
          Blindfold Capital leverages advanced automation and smart contract
          technology to create a fully transparent, secure, and self-sustaining
          trading ecosystem.
        </Text>

        <Text
          fontSize={{ base: "sm", md: "md" }}
          textAlign={{ base: "left", md: "justify" }}
        >
          Blindfold Capital’s proprietary trading infrastructure leverages
          advanced technical analysis algorithms to interpret a wide array of
          market indicators. It generates a composite trend signal that
          dynamically adjusts trading parameters. This adaptive strategy allows
          the platform to optimize risk exposure, seize market opportunities,
          support efficient exponential growth, and deliver a secure,
          transparent, and algorithm-driven trading experience.
        </Text>
      </VStack>

      {/* Contact Us Section */}
      <Center mt={6}>
        <ContactUsBox />
      </Center>
    </Container>
  );
}

export default BlindfoldInfo;
